const IMAGES_PATH = 'assets/img'

export const APP_IMAGES = {
  LOGO: `${IMAGES_PATH}/logo-fundos.svg`,
  LOGOV: `${IMAGES_PATH}/logo-fundos-vertical.svg`
}
